<template>
  <div id="content">
    <ul v-if="loading === false" class="stepper linear bg-white" id="main-stepper">
      <li class="step active">
        <div @click="moveToStep(0)" class="step-title waves-effect">
          Perfil
          <router-link v-show="active_step === 0" class="step-help" to="/Tutorial/1/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <perfil ref="0" @updateEstadoCivil="setEstadoCivil" @moveNextStep="handleMoveNextSetp"
            v-bind:perfil_data="getDadosPerfil()" v-bind:bio="social_data['bio']" v-bind:active_step="active_step"
            v-bind:stepper="stepper" />
        </div>
      </li>
      <li class="step">
        <div @click="moveToStep(1)" class="step-title waves-effect">
          Documentos
          <router-link v-show="active_step === 1" class="step-help" to="/Tutorial/2/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <documentos ref="1" @moveNextStep="handleMoveNextSetp" v-bind:documentos_data="social_data['documentos']"
            v-bind:perfil_data="getPerfilData()" v-bind:active_step="active_step" v-bind:stepper="stepper" />
        </div>
      </li>
      <li class="step">
        <div @click="moveToStep(2)" class="step-title waves-effect">
          Contatos
          <router-link v-show="active_step === 2" class="step-help" to="/Tutorial/3/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <contatos ref="2" @moveNextStep="handleMoveNextSetp"
            v-bind:contatos_data="{ 'emails': social_data['emails'], 'enderecos': social_data['enderecos'], 'telefones': social_data['telefones'] }"
            v-bind:active_step="active_step" v-bind:stepper="stepper" />
        </div>
      </li>
      <li class="step">
        <div @click="moveToStep(3)" class="step-title waves-effect">
          Dependentes
          <router-link v-show="active_step === 3" class="step-help" to="/Tutorial/4/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <dependentes ref="3" @moveNextStep="handleMoveNextSetp" v-bind:dependentes_data="social_data['familia']"
            v-bind:active_step="active_step" v-bind:stepper="stepper" />
        </div>
      </li>
      <li class="step" v-show="!isPensionista">
        <div @click="moveToStep(4)" class="step-title waves-effect">
          Dados Funcionais
          <router-link v-show="active_step === 4" class="step-help" to="/Tutorial/5/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <servidor v-if="Object.keys(rh_data).length > 0 && !isPensionista" ref="4" @moveNextStep="handleMoveNextSetp"
            v-bind:rh_dados="rh_data" v-bind:social_data_inst="social_data_inst" v-bind:gov_data="gov_data"
            v-bind:active_step="active_step" v-bind:stepper="stepper" />
        </div>
      </li>
      <li class="step">
        <div @click="moveToStep(5)" class="step-title waves-effect">
          Avaliação
          <router-link v-show="active_step === 5" class="step-help" to="/Tutorial/6/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <avaliacao ref="5" @goToStep="moveToStep" @moveNextStep="handleMoveNextSetp"
            v-bind:prev_step_index="isPensionista ? 3 : 4"
            v-bind:step_incomplete="step_incomplete" v-bind:active_step="active_step" v-bind:stepper="stepper" />
        </div>
      </li>
      <li class="step">
        <div @click="moveToStep(6)" class="step-title waves-effect">
          Imagens
          <router-link v-show="active_step === 6" class="step-help" to="/Tutorial/7/"><i
              class="material-icons">help</i></router-link>
        </div>
        <div class="step-content">
          <upload ref="6" @goToStep="moveToStep" @moveNextStep="handleMoveNextSetp" @updateStep="updateStep"
            v-bind:document_info="social_data['document_info']" v-bind:estado_civil="estado_civil"
            v-bind:servidor_info="servidor_info" v-bind:perfil_data="getPerfilData()"
            v-bind:step_incomplete="step_incomplete" v-bind:active_step="active_step" v-bind:stepper="stepper" />
        </div>
      </li>
    </ul>
    <div v-else>
      <div class="loading-wrapper">
        <loading />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import Contatos from '@/components/steps/Contatos.vue'
import Dependentes from '@/components/steps/Dependentes.vue'
import Documentos from '@/components/steps/Documentos.vue'
import Perfil from '@/components/steps/Perfil.vue'
import Servidor from '@/components/steps/Servidor.vue'
import Upload from '@/components/steps/Upload.vue'
import Avaliacao from '@/components/steps/Avaliacao.vue'
import Loading from '@/components/Loading.vue'

import { verificaData, converteData, converteIdade } from '@/assets/js/form-utils.js'
import { CONFIG } from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import RhService from '@/services/rh-service.js'
let rhService = new RhService(CONFIG.URL_RH_API_V2)
let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Home',
  components: {
    contatos: Contatos,
    dependentes: Dependentes,
    documentos: Documentos,
    perfil: Perfil,
    servidor: Servidor,
    loading: Loading,
    upload: Upload,
    avaliacao: Avaliacao,
  },
  data() {
    return {
      pf_id: this.$store.state.user.pfId, //130.404.430-03
      social_data: {},
      estado_civil: "",
      rh_data: {},
      social_data_inst: {}, //Instituidor de pensão, quando houver
      loading: true,
      stepper: null,
      active_step: 0,
      gov_data: { 'cargos': {}, 'lotacoes': {} },
      step_incomplete: 0,
    }
  },
  computed: {
    servidor_info: function () {
      return {
        cursos: ('1' in this.$refs ? this.$refs[1].cursos : 0),
        dependentes: ('3' in this.$refs ? this.$refs[3].dependentes_registered : []),
        categoria_cods: Object.keys(this.rh_data).map(s_id => this.rh_data[s_id]['categoria_cod']),
        instituidores: Object.keys(this.rh_data).map(s_id => this.rh_data[s_id]['categoria_cod'] === 3).length,
        pne: ('0' in this.$refs ? this.$refs[0].perfil.pne : 0),
        est_civil: ('0' in this.$refs ? this.$refs[0].perfil.est_civil : 0),
      }
    },
    rh_data_updated: function () {
      return this.rh_data
    },
    isPensionista: function () {
      let s_ids = Object.keys(this.rh_data)
      return s_ids.length > 0 && s_ids.every(s_id => this.rh_data[s_id]['categoria_cod'] === 3)
    }
  },
  methods: {
    setEstadoCivil(val) {
      this.estado_civil = val
    },
    updateStatusAll() {
      let incompletes = []
      for (let i = 0; i <= 6; i++) {
        try {
          // Pensionista não possui a etapa de Dados Funcionais
          if (this.isPensionista && i === 4) {
            continue
          }
          if (i === 4 && !'servidor_id' in this.rh_data) {
            incompletes.push(i)
          } else if (this.$refs[i].step_completed !== true) {
            incompletes.push(i)
          }
        } catch (e) {
          console.log(e)
        }

        if (incompletes.length > 0) {
          this.step_incomplete = Math.min(...incompletes)
        } else {
          this.step_incomplete = -1
        }
      }
    },
    updateStep(step, status) {
      if (status === true) {
        // Só libera se a pendência atual for deste passo; passo completo não gera nova pendência
        if (this.step_incomplete === step) {
          this.step_incomplete = -1
        }
      } else {
        this.step_incomplete = step
      }
    },
    getDadosPessoa() {
      socialService.exchange([this.pf_id], [
        'foto_url', 'nome', 'cpf', 'nome_social', 'sexo', 'genero', 'orientacao_sexual', 'nascimento', 'filiacao', 'obito', 'estado_civil', 'escolaridade',
        'bio', 'telefones', 'emails', 'enderecos', 'familia',
        {
          'document_info':
            [
              'all'
            ]
        },
        {
          'documentos': [
            'cpf',
            'rg',
            'cnh',
            'cert',
            'cart_class',
            'reservista',
            'cursos',
            'titulo_eleitor',
            'ppn',
            'ctps'
          ]
        }
      ], true)
        .then(async (social_data) => {
          let document_info = this.social_data.document_info
          this.social_data = social_data[this.pf_id]
          this.social_data.document_info = { ...this.social_data.document_info, ...document_info }

          await this.getServidorData()
          this.loading = false

          //setTimeout(() => this.moveToStep(1), 500)
          this.$nextTick(() => {
            M.FormSelect.init(document.querySelectorAll('select'))
            M.Tooltip.init(document.querySelectorAll('.tooltipped'))
            M.updateTextFields()
            this.getDadosPerfil()

            this.initStepper()
          })

        }).catch((error) => {
          console.log("Não foi possível carregar os dados da SocialAPI")
        })
    },
    async getServidorData() {
      axios.get(`${CONFIG.URL_RH_API_V2}/v1/servidor/pessoa/${this.pf_id}/`)
        .then(async (response) => {
          let rh_data = response.data.data.RhAPI
          let rh_exchange = await rhService.exchange(rh_data.map(m => m.servidor_id))

          //Formata todas as datas para o padrão BR
          for (let servidor_id in rh_exchange) {
            rh_exchange[servidor_id].beneficio.data_concessao = (verificaData(rh_exchange[servidor_id].beneficio.data_concessao, 'YYYY-MM-DD') === true ? converteData(rh_exchange[servidor_id].beneficio.data_concessao) : null)
            rh_exchange[servidor_id].data_movimento = (verificaData(rh_exchange[servidor_id].data_movimento, 'YYYY-MM-DD') === true ? converteData(rh_exchange[servidor_id].data_movimento) : null)
            rh_exchange[servidor_id].lotacao.data_ingresso = (verificaData(rh_exchange[servidor_id].lotacao.data_ingresso, 'YYYY-MM-DD') === true ? converteData(rh_exchange[servidor_id].lotacao.data_ingresso) : null)
            rh_exchange[servidor_id]['extras'] = {}
            rh_exchange[servidor_id]['instituidor'] = {}
            rh_exchange[servidor_id]['pensionistas_obj'] = {}

            //Organiza os pensionistas em obj indexado pelos seus respectivos pf_ids, por motivos de 2-WAY data-biding
            rh_exchange[servidor_id].pensionistas.forEach(p => {
              p['data_concessao'] = (verificaData(p['data_concessao'], 'YYYY-MM-DD') ? converteData(p['data_concessao']) : null)
              rh_exchange[servidor_id]['pensionistas_obj'][p['pf_id']] = p
            })

            //Seta a categoria de benefício e a regra, quando se tratar de inativo ou pensionista
            if (rh_exchange[servidor_id].categoria_cod === 2) {
              rh_exchange[servidor_id].beneficio.tipo = 'aposentadoria'
            } else if (rh_exchange[servidor_id].categoria_cod === 3) {
              rh_exchange[servidor_id].beneficio.tipo = 'pensao'
              rh_exchange[servidor_id].beneficio.regra = 'pensao'
            }
          }

          this.rh_data = rh_exchange
          let pf_id_instituidores = rh_data.map(m => (m.categoria_cod === 3 ? m.pf_id : null)).filter(p => p !== null)

          if (pf_id_instituidores.length > 0) {
            socialService.exchange(pf_id_instituidores, [
              'nome', 'cpf', 'nascimento', 'obito',
              {
                'documentos': [
                  'ppn',
                ]
              }
            ], true)
              .then(async (social_data) => {
                for (let pf_id_instituidor in social_data) {
                  for (let servidor_id in rh_exchange) {
                    if (rh_exchange[servidor_id]['pf_id'] === pf_id_instituidor) {
                      social_data[pf_id_instituidor].nascimento = (verificaData(social_data[pf_id_instituidor].nascimento, 'YYYY-MM-DD') ? converteData(social_data[pf_id_instituidor].nascimento) : null)
                      social_data[pf_id_instituidor].obito = (verificaData(social_data[pf_id_instituidor].obito, 'YYYY-MM-DD') ? converteData(social_data[pf_id_instituidor].obito) : null)
                      this.$set(this.rh_data[servidor_id], 'instituidor', {
                        ...social_data[pf_id_instituidor],
                        ...{
                          ppn: ('ppn' in social_data[pf_id_instituidor].documentos.ppn ? social_data[pf_id_instituidor].documentos.ppn.ppn : null),
                          cpf_loaded: social_data[pf_id_instituidor].cpf
                        }
                      })
                    }
                  }
                }
              })
              .finally(() => {
              })
          }

          for (let servidor_id in rh_exchange) {
            axios.get(`${CONFIG.URL_RH_API_V2}/v2/servidor/extras/${servidor_id}/${rh_exchange[servidor_id]['pf_id']}/titular/`)
              .then(async (response) => {
                this.$set(this.rh_data[servidor_id], 'extras', response.data.data.RhAPI)
              })
              .catch(async (error) => { })
          }
        })
        .catch((error) => {
        })
    },
    async loadCargos() {
      axios.get(`${CONFIG.URL_GOV_API}/v1/cargo/`)
        .then((response) => {
          response.data.data.GovernancaAPI.forEach((cargo) => {
            this.$set(this.gov_data['cargos'], cargo['cargo_id'], cargo)
          })
        }).catch((error) => {
          if (error.response.status != 404) {
            console.error(error)
          }
        })
    },
    async loadLotacoes() {
      axios.get(`${CONFIG.URL_GOV_API}/v1/lotacao/`)
        .then((response) => {
          response.data.data.GovernancaAPI.forEach((lot) => {
            this.$set(this.gov_data['lotacoes'], lot['lotacao_id'], lot)
          })
        }).catch((error) => {
          if (error.response.status != 404) {
            console.error(error)
          }
        })
    },
    getDocsRecad() {
      axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/servidor/document/${this.pf_id}/all/`)
        .then((response) => {
          this.social_data.document_info = { ...this.social_data.document_info, ...response.data.data.RecadAPI }
        })
        .catch((error) => {
          this.social_data.document_info = {
            ...this.social_data.document_info, ...{
              'i0k6d5': [],
              'er0zqc': [],
              'ebdf70': [],
              'd06f17': [],
              'cnis': [],
            }
          }
        })
    },
    getDadosPerfil() {
      if (this.social_data) {
        return {
          'foto_url': (this.social_data.document_info.wa9tia.private.length > 0 ? this.social_data.document_info.wa9tia.private[0].file_id : null),
          'pf_nome': this.social_data['nome'],
          'pf_cpf': this.social_data['cpf'],
          'pf_cpf_valid': this.social_data['pf_cpf_valid'],
          'pf_nome_social': this.social_data['nome_social'],
          'pf_nascimento': this.social_data['nascimento'],
          'pf_sexo': this.social_data['sexo'],
          'pf_genero': this.social_data['genero'],
          'pf_orientacao_sexual': this.social_data['orientacao_sexual'],
          'pf_escol': this.social_data['escolaridade'],
          'pf_est_civil': this.social_data['estado_civil'],
          'filiacao': this.social_data['filiacao'],
          'pf_obito': this.social_data['obito'],
        }
      }
    },
    handleMoveNextSetp(step_info) {
      let step = step_info['step']
      let step_completed = step_info['completed']
      let next_step = step + 1

      if (this.isPensionista && next_step === 4) {
        next_step = 5
      }

      if (step < 6) {
        this.stepper.openStep(next_step)
      } else {
        this.stepper.closeStep(step)
      }

      this.updateStatusStep(step, step_completed)

    },
    updateStatusStep(step, step_completed) {

      //Remove ambos status primeiro
      document.querySelectorAll('#main-stepper > li')[step].classList.remove('wrong')
      document.querySelectorAll('#main-stepper > li')[step].classList.remove('done')

      if (step_completed === false) {
        document.querySelectorAll('#main-stepper > li')[step].classList.add('wrong')
      } else {
        document.querySelectorAll('#main-stepper > li')[step].classList.add('done')
      }
    },
    moveToStep(step){
      // Pensionista não acessa a etapa de Dados Funcionais (índice 4)
      if (this.isPensionista && step === 4) {
        step = 3
      }
      this.stepper.openStep(step)
    },
    initStepper() {
      setTimeout(() => {
        var stepper = document.querySelector('.stepper')
        this.stepper = new MStepper(stepper, {
          firstActive: 0,
          autoFormCreation: false
        })

        document.getElementById('main-stepper').addEventListener('stepopen', () => {

          //Step closed
          if (this.$refs[this.active_step]) {
            this.updateStatusStep(this.active_step, this.$refs[this.active_step].step_completed)
          }

          //Step open
          setTimeout(() => {
            this.active_step = this.stepper.getSteps().active.index
            // A etapa de Dados Funcionais (índice 4) não é renderizada para pensionista
            if (!this.$refs[this.active_step]) {
              return
            }
            this.$refs[this.active_step].initStep()
            setTimeout(() => {
              this.$refs[this.active_step].verificaStatusPasso()
            }, 500)
          }, 300)
        }, true)
      }, 400)
    },
    verificaStatusCadastro() {
      axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/higienize-segurado/${this.pf_id}/`)
        .then((response) => {
          //FILA DE HIGIENIZAÇÃO OU HIGIENIZADO
          if (['locked', 'done'].includes(response.data.data.RecadAPI.status)) {
            this.$router.push('/Status/')
          } else {
            if (!localStorage.hasOwnProperty('reviewd') || localStorage.getItem('reviewd') != 'true') {
              localStorage.setItem('reviewd', 'true')
              this.$router.push('/Review/')
            } else {
              this.loadSeguradoData()
            }
          }
        })
        .catch((error) => {
          //Cadastro aberto
          if (error.response.status === 404) {
            this.loadSeguradoData()
          } else {
            M.toast({ html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes." })
            this.router.push('/')
          }
        })
    },
    loadSeguradoData() {
      this.getDadosPessoa()
      this.getDocsRecad()
      this.getServidorData()
      this.loadLotacoes()
      this.loadCargos()
    },
    getServidorInfo() {
      return {
        cursos: ('2' in this.$refs ? this.$refs[2].cursos : []),
        dependentes: ('3' in this.$refs ? this.$refs[3].dependentes.length : 0),
        categoria_cods: Object.keys(this.rh_data).map(s_id => this.rh_data[s_id]['categoria_cod'])
      }
    },
    getPerfilData() {
      let idade = 10
      let sexo = 'X'

      if ('0' in this.$refs) {
        idade = converteIdade(this.$refs[0].perfil.nascimento, "DD/MM/YYYY")
        sexo = (this.$refs[0].perfil.sexo && this.$refs[0].perfil.sexo.charAt(0) == 'm' ? 'M' : 'F')
      }

      return {
        'idade': idade,
        'sexo': sexo
      }
    }
  },
  watch: {
    active_step: {
      handler: function (a, b) {
        this.$nextTick(() => this.updateStatusAll())
      }
    }
  },
  mounted() {
    this.verificaStatusCadastro()
    this.$root.$emit('stopLoadingHeader')
  }
}
</script>
<style scoped>
.bg-white {
    background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue